import axios from 'axios';
import React, { useEffect, useState } from 'react';

function Footer() {
  const [ads, setAds] = useState([]);
  const handleRefresh = () => {
    window.scrollTo(0, 0); 
    window.location.reload();
  };
  
  const getData = async () => {
    try {
      const result = await axios.get(`${process.env.REACT_APP_DNAME}/getads`);
      if (result && result.data) {
        setAds(result.data);
      } else {
        setAds([]);
      }
    } catch (error) {
      console.error("Error fetching ads:", error);
    }
  };
  
  useEffect(() => {
    getData();
  }, []);
  
  const targetSite = 'A1 Satta King';
  const currentAd = ads
    .filter(a => a.website === targetSite || a.website === 'Both')
    .sort((a, b) => (a.orderA1 || 0) - (b.orderA1 || 0))[0] || ads[0];

  return (
    <div className="text-xs mt-4 relative">
      <div className="fixed bottom-10 left-5 right-10 flex justify-between items-center z-10">
        <div className='border border-slate-600 rounded-full shadow-lg shadow-slate-700 bg-white'>
          <a target='_blank' rel="noreferrer" href={`https://wa.me/${currentAd?.phoneNo}`} id="body_contactwa"><strong>
            <img 
              className='rounded-full h-12 w-12 object-cover' 
              loading="lazy" 
              src={require("./logo.png")} 
              alt="Whatsapp to show game on this website" 
            /></strong></a>
        </div>
        <div className='border border-slate-600 bg-black rounded-full shadow-lg shadow-slate-700'>
          <button onClick={handleRefresh} className='rounded-full  w-28 flex justify-center items-center'>
            <img className=' h-full' loading="lazy" src={require("./refreshimage.png")} alt="Refresh button" />
          </button>
        </div>
      </div>

      <p>
        !! DISCLAIMER:-a1sattaking.net is a non-commercial website. Viewing This Website Is Your Own Risk, All The
        Information Shown On Website Is Sponsored And We Warn You That Matka Gambling/Satta May Be Banned Or Illegal
        In Your Country..., We Are Not Responsible For Any Issues Or Scam..., We Respect All Country Rules/Laws...
        If You Not Agree With Our Site Disclaimer... Please Quit Our Site Right Now. Thank You..
      </p>
      <div>
        <div className="bg-yellow-200 text-sm p-2 text-center"><strong>2018-2023 ©️a1sattaking.net All rights reserved </strong></div>
      </div>
    </div>
  );
}

export default Footer;
